// @ts-nocheck
/* eslint-disable react/no-danger */
import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { Tooltip } from 'react-tippy';
import { formatters } from 'jsondiffpatch';
import UIInfiniteScroll from 'components/UI/InfiniteScroll/InfiniteScroll';
import { AUDIT_LOG_ACTIONS_LABEL } from 'components/AuditLog/constants';
import { longDateFormatWithTimeWithSeconds } from 'components/utils/formats';
import 'components/AuditLog/utils/jsondiffpatch.css';
import './List.scss';

const cbn = 'audit-log-popup-list';

type IAuditLogPopupListProps = {
  logs;
  fetchMore: () => void;
  hasMore: boolean;
  loading: boolean;
  hasError: boolean;
};

function AuditLogPopupList({
  logs,
  fetchMore,
  hasMore = false,
  loading = false,
  hasError = false,
}: IAuditLogPopupListProps) {
  const wrapperRef = useRef(null);
  const prevLogsRef = useRef(logs);

  function scrollToBottom(smooth) {
    if (wrapperRef.current) {
      if ('scrollTo' in wrapperRef.current) {
        wrapperRef.current.scrollTo({
          top: 0,
          behavior: smooth ? 'smooth' : undefined,
        });
      } else {
        wrapperRef.current.scrollTop = 0;
      }
    }
  }

  useEffect(() => {
    const prevLength = prevLogsRef.current?.length;
    if (!prevLength && logs.length) {
      scrollToBottom(false);
    }
    prevLogsRef.current = logs;
  }, [logs]);

  return (
    <div ref={wrapperRef} className={cbn}>
      {[...logs].reverse().map((log) => (
        <div key={log.id} className={`${cbn}__item`}>
          <a
            className={`${cbn}__item__link`}
            target="_blank"
            rel="noopener noreferrer"
            href={`/auditlog/${log.id}`}
          >
            <span className={`${cbn}__item__meta`}>
              <span className={`${cbn}__item__meta__date`}>
                {moment(log.createdAt).format(
                  longDateFormatWithTimeWithSeconds,
                )}
              </span>
              {' '}
              -&nbsp;
              <span className={`${cbn}__item__meta__action`}>
                {(
                  AUDIT_LOG_ACTIONS_LABEL[log.action] || log.action
                ).toUpperCase()}
              </span>
              {' '}
              by&nbsp;
              <span className={`${cbn}__item__meta__author-name`}>
                {log.authorSnapshot?.name}
              </span>
            </span>
          </a>
          <span className={`${cbn}__item__diffs`}>
            {log.diff &&
              Object.entries(log.diff).map(([key, diff]) => (
                <span key={key} className={`${cbn}__item__diff`}>
                  <Tooltip
                    className={`${cbn}__item__diff__tooltip__wrapper`}
                    position="bottom"
                    arrow
                    unmountHTMLWhenHide
                    theme="light"
                    html={
                      <div
                        className={`${cbn}__item__diff__tooltip__content`}
                        dangerouslySetInnerHTML={{
                          __html: formatters.html.format(diff, null),
                        }}
                      />
                    }
                  >
                    <span className={`${cbn}__item__diff__tooltip__label`}>
                      {key}
                    </span>
                  </Tooltip>
                </span>
              ))}
            {!log.diff && log.message && <span>
              {' '}
              {log.message}
              {' '}
            </span>}
          </span>
        </div>
      ))}
      {logs?.length > 0 && !hasError && !loading && hasMore && (
        <UIInfiniteScroll fetchMore={fetchMore} />
      )}
      {!logs.length && !loading && <div> No Results found</div>}
    </div>
  );
}

export default AuditLogPopupList;
